module.exports = __webpack_public_path__ + "static/media/taller_panoramica.5bdda723.png";